import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';

@Component({
  selector: 'app-assignee-renderer',
  templateUrl: './assignee-renderer.component.html',
  styleUrls: ['./assignee-renderer.component.scss'],
  standalone: false,
})
export class AssigneeRendererComponent {
  assignee?: string;

  agInit(params: ICellRendererParams): void {
    this.assignee = params.value;
  }
}
